import React from 'react'
import yellowlogo from '../images/yellowlogo.svg'

import { Link, useNavigate } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'


const Footer = () => {
  const navigate = useNavigate
  return (
    <Container fluid style={{background: '#333333',borderTop: '1px solid #000000'}} className='px-auto pt-5 pb-3 mt-auto'>
      <footer className='px-2 mx-lg-5 px-lg-5 px-md-4' >
        <Row className=''>


          <Col md={3} className="mb-md-0 mb-4 group2 d-flex d-md-block justify-content-between">
            <div>
                <Link to='/'>
                <img src={yellowlogo} alt="logo" className="yellowlogo" width="110px"/>
                </Link>
                <p className="motto mt-2 text-light">Committed to providing you smooth travels</p>
            </div>
            <div className='d-block d-md-flex'>
                <ul className='d-block d-md-flex p-md-0 m-md-0' style={{listStyle:'none'}}>
                  <li>
                  <a href="#" target="_blank">
                    <img src="https://img.icons8.com/color/32/null/google-logo.png" alt="Google-icons" className="footer-img" />
                  </a>
                  </li>
                  <li>
                  <a href="#" target="_blank">
                    <img src="https://img.icons8.com/color/32/null/facebook-new.png" alt="facebook-icons" className="footer-img" />
                  </a>
                  </li>
                  <li>
                  <a href="#" target="_blank">
                    <img src="https://img.icons8.com/fluency/32/null/instagram-new.png" alt="Insta-icons" className="footer-img" />
                  </a>
                  </li>
               </ul>
              </div>
              </Col>




          <Col >
            <div>
            <Row className=''>
                      <Col xs={4} md={3} className="mb-md-0 mb-4 ">
                        <h6 className="footer-heading text-light mb-2">Company</h6>
                        <p>
                          <Link to="/about" className="text-decoration-none text-white">About Us</Link>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="#">Our Services</a>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="#">How we work</a>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="#">Careers</a>
                        </p>
                      </Col>
                      <Col xs={4} md={3} className="mb-md-0 mb-4">
                        <h6 className="footer-heading text-light mb-2">Quick Links</h6>
                        <p>
                          <Link to="/explore" className="text-decoration-none text-white" >Explore</Link>
                        </p>
                        <p>
                          <Link to="/booking" className="text-decoration-none text-white" >Bookings</Link>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="html/Car.html">Transportation</a>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="#">Low Fare Tips</a>
                        </p>
                      </Col>
                      <Col  xs={4} md={3} className="mb-md-0 mb-4 ps-5 ps-md-3 ps-lg-0">
                        <h6 className="footer-heading text-light mb-2">Contact</h6>
                        <p>
                          <Link to="/faq" className="text-decoration-none text-white">FAQs</Link>
                        </p>

                        <p>
                          <Link to="/contact" className="text-decoration-none text-white">Contact</Link>
                        </p>
                        
                        
                        <p>
                          <a className="text-decoration-none text-white" href="#">Partners</a>
                        </p>
                        <p>
                          <a className="text-decoration-none text-white" href="#">Affiliates</a>
                        </p>
                      </Col>
              </Row>


            </div>
            
          </Col>
          
        </Row>
        <hr style={{color: "white"}}/>
        <p className='mt-4 footer-text  mx-md-auto mx-4' style={{color: "white", textAlign: "center"}}>© 2023 Tripz, Inc. All rights deserved.</p>
      </footer>
     
    </Container>
    
  )
}

export default Footer